import React from 'react';
const colorVariantsIndicatorUrl = 'https://cdn.migros.ch/ch.migros.shared-components/latest/img/variantColorIndicator/variant-color-indicator.png';
const colorVariantsIndicatorRetinaUrl = 'https://cdn.migros.ch/ch.migros.shared-components/latest/img/variantColorIndicator/variant-color-indicator@2x.png';
export const ColorVariantsIndicator = ({
  colorVariantsHint
}) => {
  return /*#__PURE__*/React.createElement("img", {
    src: colorVariantsIndicatorUrl,
    srcSet: `${colorVariantsIndicatorUrl} 1x, ${colorVariantsIndicatorRetinaUrl} 2x`,
    alt: colorVariantsHint ? colorVariantsHint : '',
    "data-testid": "msrc-articles--color-variants-indicator"
  });
};